import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { SignIn, ArrowLeft } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLoginPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/clubs/login`, { email, password });
      
      // Store token
      localStorage.setItem(`club_admin_${response.data.club.slug}`, response.data.token);
      
      // Redirect to club admin
      const base = window.location.pathname.split('/')[1] || 'worldcup2026';
      navigate(`/${base}/${response.data.club.slug}/admin`);
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: 'var(--bg-main)' }}>
      <div className="max-w-md w-full">
        <button 
          onClick={() => navigate(`/${window.location.pathname.split('/')[1] || 'worldcup2026'}/${slug}`)}
          className="text-gray-400 hover:text-white transition-colors mb-8 flex items-center gap-2"
          data-testid="back-to-club-btn"
        >
          <ArrowLeft size={20} /> Back to Predictor
        </button>

        <div className="card p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl mb-2" style={{ fontFamily: 'Barlow Condensed, sans-serif' }} data-testid="login-title">
              Club Admin Login
            </h1>
            <p className="text-gray-400">Access your World Cup Predictor dashboard</p>
          </div>

          <form onSubmit={handleLogin}>
            <div className="space-y-4">
              <div>
                <label className="block text-sm text-gray-400 mb-2">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input-field w-full"
                  placeholder="admin@yourclub.com"
                  required
                  data-testid="email-input"
                />
              </div>
              
              <div>
                <label className="block text-sm text-gray-400 mb-2">Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="input-field w-full"
                  placeholder="••••••••"
                  required
                  data-testid="password-input"
                />
              </div>
            </div>

            {error && (
              <div className="mt-4 p-3 bg-red-900/20 border border-red-500 text-red-400 text-sm" data-testid="error-message">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full mt-6 flex items-center justify-center gap-2"
              data-testid="login-btn"
            >
              {loading ? (
                <>
                  <div className="w-5 h-5 border-2 border-t-transparent border-black rounded-full animate-spin" />
                  Logging in...
                </>
              ) : (
                <>
                  <SignIn size={20} weight="bold" />
                  Login
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
